<template>
	<div class="dialog" style="max-height: 800px; transform: translate(0, -1380px)" @mouseup="dragEnd()">
		<div class="top">
			<p class="txt-crud-title">
				Capturing Data List
			</p>
		</div>
		<div class="center">
			<div class="search-container">
        <div class="search-header">
          <input 
            type="text" 
            class="input-list-search" 
            placeholder="Quick search..." 
            v-model="searchText" 
            @keyup.enter="quickSearch()"
            style="margin: 0 0 10px 0;"
          >
          <button class="btn-advanced-search" @click="toggleAdvancedSearch">
            {{ showAdvancedSearch ? 'Hide Advanced Search' : 'Show Advanced Search' }}
          </button>
        </div>
        
        <div v-if="showAdvancedSearch" class="advanced-search-panel">
          <div v-for="(condition, index) in searchConditions" :key="index" class="search-condition">
            <select v-model="condition.column" class="search-select">
              <option value="">Select Column</option>
              <option v-for="col in searchableColumns" :key="col.columnName" :value="col">
                {{ col.columnEnglishName }}
              </option>
            </select>
            
            <select v-model="condition.operator" class="search-select">
              <template v-if="isDateColumn(condition.column)">
                <option value="dateBetween">기간 검색</option>
                <option value="dateEquals">해당 일자</option>
                <option value="dateBefore">이전 일자</option>
                <option value="dateAfter">이후 일자</option>
              </template>
              <template v-else>
                <option value="contains">contains</option>
                <option value="equals">equals</option>
                <option value="startsWith">starts with</option>
                <option value="endsWith">ends with</option>
                <option value="empty">is empty</option>
                <option value="notEmpty">is not empty</option>
              </template>
            </select>
            
            <!-- Date range picker for date fields -->
            <div v-if="isDateColumn(condition.column) && condition.operator === 'dateBetween'" class="date-range-picker">
              <input
                type="date"
                v-model="condition.startDate"
                class="search-input date-input"
                placeholder="시작일"
              >
              <span class="date-separator">~</span>
              <input
                type="date"
                v-model="condition.endDate"
                class="search-input date-input"
                placeholder="종료일"
              >
            </div>
            
            <!-- Single date picker for other date operations -->
            <input
              v-else-if="isDateColumn(condition.column) && ['dateEquals', 'dateBefore', 'dateAfter'].includes(condition.operator)"
              type="date"
              v-model="condition.value"
              class="search-input"
              :placeholder="getDatePlaceholder(condition.operator)"
            >
            
            <!-- Regular text input for non-date fields -->
            <input 
              v-else-if="!['empty', 'notEmpty'].includes(condition.operator)"
              type="text" 
              v-model="condition.value" 
              class="search-input"
              placeholder="Enter value"			  
              @keyup.enter="applyAdvancedSearch"
            >
            
            <select v-model="condition.connector" v-if="index < searchConditions.length - 1" class="search-select">
              <option value="AND">AND</option>
              <option value="OR">OR</option>
            </select>
            
            <button @click="removeCondition(index)" class="btn-remove" title="Remove condition">
              ×
            </button>
          </div>
          
          <div class="search-actions">
            <button @click="addCondition" class="btn-add">+ Add Condition</button>
            <button @mouseup.stop="" @click="applyAdvancedSearch" class="btn-apply">Apply Search</button>
            <button @click="resetSearch" class="btn-reset">Reset</button>
          </div>
        </div>
      </div>
			<div ref="scrollWrap" class="scroll-wrap scroll" style="overflow: scroll;">
				<div class="scroll-thead-wrap" style="width: 100%; overflow: visible;">
					<table class="tb-list-vertical">
						<thead>
							<tr>
								<th></th>
								<th v-if="dataList.length != 0">No</th>
								<th v-for="(col, colIndex) in columnList" :key="colIndex">
									{{col.columnEnglishName}}
								</th>
							</tr>
						</thead>
						<tbody>
							<template v-for="(data, dataIndex) in dataList">
								<tr v-if="showRow[dataIndex] == true" :key="dataIndex">
									<td>
										<input
											type="checkbox"
											class="emr-check"
											v-model="dataList[dataIndex].isChecked"
										/>
									</td>
									<td>
										{{ dataIndex + 1 }}
									</td>
									<template v-for="(col, colIndex) in columnList">
										<td
											v-if="data[col.columnName] !== undefined"
											:key="colIndex"
											:class="(showRow[dataIndex] == true && data[col.columnName].indexOf(searchText) >= 0 && searchText != '' ? 'yellow' : '')"
										>
											{{ data[col.columnName] }}
										</td>
										<td
											v-if="data[col.columnName] === undefined"
											:key="colIndex"
											style="color: #ccc;"
										>
											(EMPTY)
										</td>
									</template>
								</tr>
							</template>
							<tr v-if="dataList.length == 0">
								<td :colspan="columnList.length + 2" class="no-list">
									There is no registered data, Please register the data.
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="scroll-tbody-wrap" @scroll="scrollPaging($event)" style="width: 100%; overflow: visible; z-index: 11;">
					<table class="tb-list-vertical no-drag">
						<thead>
							<tr>
								<th></th>
								<th v-if="dataList.length != 0">No</th>
								<th
									v-for="(col, colIndex) in columnList"
									:key="colIndex"
								>
									{{col.columnEnglishName}}
								</th>
							</tr>
						</thead>
						<!-- <tbody @mousedown="dragStart($event)" @mousemove="dragging($event)"> -->
						<tbody>
							<template v-for="(data, dataIndex) in dataList">
								<tr v-if="showRow[dataIndex] == true" :key="dataIndex">
									<td>
										<!-- <input
											type="checkbox"
											class="emr-check"
											v-model="dataList[dataIndex].isChecked"
										/> -->
										<input
											type="checkbox"
											name="dataNo"
											:checked="(checkedList.indexOf(data.dataNo) >= 0 ? true : false)"
											@click="check(data)"
										/>
									</td>
									<td>
										{{ dataIndex + 1 }}
									</td>
									<template v-for="(col, colIndex) in columnList">
										<td
											v-if="data[col.columnName] !== undefined"
											:key="colIndex"
											:class="(showRow[dataIndex] == true && data[col.columnName].indexOf(searchText) >= 0 && searchText != '' ? 'yellow' : '')"
										>
											{{ data[col.columnName] }}
										</td>
										<td
											v-if="data[col.columnName] === undefined"
											:key="colIndex"
											style="color: #ccc;"
										>
											(EMPTY)
										</td>
									</template>
								</tr>
							</template>
							<tr v-if="dataList.length == 0">
								<td :colspan="columnList.length + 2" class="no-list">
									There is no registered data, Please register the data.
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="bottom" style="position: relative;">
			<div v-if="isLoading" class="row-loading">
				<img src="@/assets/images/common/row-loading.png" alt="" />
				Row Loading
			</div>
			<button type="button" class="btn-save fright" title="Import" @click="doImport()">
				Get
			</button>
			<button type="button" class="btn-cancel fright" title="Cancel" @click="doCancel()">
				Cancel
			</button>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";

export default {
	name: "screeningEmrList",
	components: {},
	created() {
		this.logger.debug(this, "created()");
		this.dataPagination.currentPage = 1;
		this.dataPagination.perPage = 100;
		this.selectColumnList();
	},
	data() {
		return {
			item: {},
			columnList: [],
			dataList: [],
			checkedList: [],
			dataPagination: {},
			showRow: {},
			searchText: "",
			isDrag: false,
			dragData: {},
			isLoading: false,
			// Advanced search related data
			showAdvancedSearch: false,
			searchConditions: [
				{ 
					column: '', 
					operator: 'contains', 
					value: '', 
					startDate: '', 
					endDate: '',
					connector: 'AND' 
				}
			],
			searchableColumns: []
		};
	},
	methods: {
		isDateColumn(column) {
		if (!column.columnEnglishName) return false;
		// 일, 일자, 일시, 시기 date, day로 끝나면 true
		const dateStrSuffix = ["일", "일자", "일시", "시기", "date", "day"];
		return dateStrSuffix.some(suffix => column.columnEnglishName.endsWith(suffix));
		},
		
		getColumnEnglishName(columnName) {
		const column = this.columnList.find(col => col.columnName === columnName);
		return column ? column.columnEnglishName : '';
		},
		
		getDatePlaceholder(operator) {
		switch(operator) {
			case 'dateEquals': return '날짜를 선택하세요';
			case 'dateBefore': return '이전 날짜 선택';
			case 'dateAfter': return '이후 날짜 선택';
			default: return '날짜를 선택하세요';
		}
		},
		
		formatDate(date) {
		if (!date) return '';
		const d = new Date(date);
		if (isNaN(d.getTime())) return '';
		return d.toISOString().split('T')[0];
		},
		
		toggleAdvancedSearch() {
		this.showAdvancedSearch = !this.showAdvancedSearch;
		if (this.showAdvancedSearch && this.searchableColumns.length === 0) {
			this.searchableColumns = [...this.columnList];
		}
		},
		
		addCondition() {
		this.searchConditions.push({ 
			column: '', 
			operator: 'contains', 
			value: '', 
			startDate: '', 
			endDate: '',
			connector: 'AND' 
		});
		},
		
		removeCondition(index) {
		if (this.searchConditions.length > 1) {
			this.searchConditions.splice(index, 1);
		}
		},
		
		quickSearch() {
			if (this.searchText.trim() === '') {
				this.resetSearch();
				return;
			}
		
			// Reset to single condition for quick search
			this.searchConditions = [
				{ column: '', operator: 'contains', value: this.searchText, connector: 'AND' }
			];
			
			this.applyAdvancedSearch();
		},
		
		applyAdvancedSearch() {
			this.logger.debug(this, "applyAdvancedSearch()");
			EventBus.$emit("project-loading", true);
		
			// 새로운 showRow 배열 생성
			const newShowRow = Array(this.dataList.length).fill(true);
		
			// 조건에 따라 showRow 업데이트
			this.searchConditions.forEach(condition => {
				if (!condition.column) return;
				
				const column = this.columnList.find(col => col.columnName === condition.column.columnName);
				if (!column) return;
			
				const columnName = column.columnName;
				const operator = condition.operator;
				const isDateField = this.isDateColumn(column);
			
				this.dataList.forEach((data, dataIndex) => {
					if (!newShowRow[dataIndex] && condition.connector !== 'OR') return;
					
					const cellValue = data[columnName] ? data[columnName].toString() : '';
					let matches = false;
					
					if (isDateField) {
						const cellDate = new Date(cellValue);
						const isValidDate = !isNaN(cellDate.getTime());
					
						if (!isValidDate) {
							matches = false;
						} else {
							let startDate, endDate, targetDate, nextDay, beforeDate, afterDate;
						
							switch (operator) {
								case 'dateBetween':
									startDate = condition.startDate ? new Date(condition.startDate) : null;
									endDate = condition.endDate ? new Date(condition.endDate) : null;
								
									if (startDate) startDate.setHours(0, 0, 0, 0);
									if (endDate) endDate.setHours(23, 59, 59, 999);
								
									matches = (!startDate || cellDate >= startDate) && 
											  (!endDate || cellDate <= endDate);
									break;
								
								case 'dateEquals':
									targetDate = condition.value ? new Date(condition.value) : null;
									if (targetDate) {
										targetDate.setHours(0, 0, 0, 0);
										nextDay = new Date(targetDate);
										nextDay.setDate(nextDay.getDate() + 1);
										matches = cellDate >= targetDate && cellDate < nextDay;
									}
									break;
								
								case 'dateBefore':
									beforeDate = condition.value ? new Date(condition.value) : null;
									if (beforeDate) {
										beforeDate.setHours(23, 59, 59, 999);
										matches = cellDate <= beforeDate;
									}
									break;
								
								case 'dateAfter':
									afterDate = condition.value ? new Date(condition.value) : null;
									if (afterDate) {
										afterDate.setHours(0, 0, 0, 0);
										matches = cellDate >= afterDate;
									}
									break;
								
								default:
									matches = false;
							}
						}
					}
					else {
						// 텍스트 조건에 따라 showRow 업데이트
						const searchValue = (condition.value || '').toString().toLowerCase();
						const cellValueLower = cellValue.toLowerCase();
					
						switch (operator) {
							case 'contains':
								matches = cellValueLower.includes(searchValue);
								break;
							case 'equals':
								matches = cellValueLower === searchValue;
								break;
							case 'startsWith':
								matches = cellValueLower.startsWith(searchValue);
								break;
							case 'endsWith':
								matches = cellValueLower.endsWith(searchValue);
								break;
							case 'empty':
								matches = !cellValue || cellValue.trim() === '';
								break;
							case 'notEmpty':
								matches = !!cellValue && cellValue.trim() !== '';
								break;
							default:
								matches = false;
						}
					}
				
					// 조건에 따라 showRow 업데이트
					if (dataIndex > 0 && condition.connector === 'OR') {
						newShowRow[dataIndex] = newShowRow[dataIndex] || matches;
					} else {
						newShowRow[dataIndex] = newShowRow[dataIndex] && matches;
					}
				});
			});
			
			// showRow 업데이트
			this.showRow = [...newShowRow];
			EventBus.$emit("project-loading", false);
		},
		
		resetSearch() {
			this.searchText = '';
			this.searchConditions = [{ column: '', operator: 'contains', value: '', connector: 'AND' }];
			this.dataList.forEach((_, index) => {
				this.$set(this.showRow, index, true);
			});
		},
		
		selectSearchText() {
			EventBus.$emit("project-loading", true);
			this.dataPagination.searchText = this.searchText;
			this.dataPagination.currentPage = 0;
			this.selectDataList();
			for(let i = 0 ; i < this.dataList.length ; i++)
			{
				let equalCount = 0;
				for(let j = 0 ; j < this.columnList.length ; j++)
				{
					if(typeof this.dataList[i][this.columnList[j].columnName] !== "undefined")
					{
						if(this.dataList[i][this.columnList[j].columnName].indexOf(this.searchText) >= 0) {
							equalCount++;
						}
					}
				}
				if(equalCount > 0)
				{
					this.showRow[i] = true;
				}
				else
				{
					this.showRow[i] = false;
				}
			}
		},
		selectColumnList() {
			this.logger.debug(this, "selectColumnList()");
			this.item = {
				searchProjectNo : this.$route.params.projectNo
			}
			axios
				.post(this.config.contextRoot + "/emr/selectColumnOneList.do", this.item)
				.then((response) => {
					console.log(response);
					this.columnList = response.data.emrColumnOneList;
					this.selectDataList();
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		selectDataList() {
			this.logger.debug(this, "selectDataList()");
			this.dataPagination = {
				searchProjectNo : this.$route.params.projectNo
			}
			axios
				.post(this.config.contextRoot + "/emr/selectDataList.do", this.dataPagination)
				.then((response) => {
					console.log(response);
					this.$set(this, "dataList", response.data.emrDataList);

					this.showRow = new Object();
					for(let i = 0 ; i < this.dataList.length ; i++)
					{
						this.showRow[i] = true;
					}

					this.$nextTick(function () {
						this.isLoading = false;
						EventBus.$emit("project-loading", false);
					});
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doImport() {
			this.logger.debug(this, "selectDataList()");
			// let checkedList = this.dataList.filter((item) => {
			// 	return item.isChecked !== undefined && item.isChecked == true
			// });
			axios
				.post(this.config.contextRoot + "/emr/selectConvertedEmrData.do", this.checkedList)
				.then((response) => {
					console.log(response);

					let resultList = response.data.resultList;
					EventBus.$emit("emr-import", resultList);

					this.doClose();
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		check(dataNo) {
			this.logger.debug(this, "check(dataNo)");
			let index = this.checkedList.indexOf(dataNo);
			if(index >= 0)
			{
				this.checkedList.splice(index, 1);
			}
			else
			{
				this.checkedList.push(dataNo);
			}
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("Do you want to cancel the import data?", "Question", "question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			EventBus.$emit("emr-close");
		},
		dragStart(event) {
			this.logger.debug(this, "dragStart(event)");
			this.isDrag = true;
			this.dragData.startX = event.clientX;
		},
		dragEnd() {
			this.logger.debug(this, "dragEnd()");
			this.isDrag = false;
		},
		dragging(event) {
			if(this.isDrag)
			{
				let classList = event.path.map(item => {
					return item.className;
				});
				let index = classList.indexOf("scroll-wrap");

				let dragX = event.clientX;
				let direct = dragX - this.dragData.startX;
				let scollLeft = event.path[index].scrollLeft;
				
				event.path[index].scrollLeft = scollLeft - direct;
				this.dragData.startX = event.clientX;
			}
		},
		scrollPaging(event) {
			let clientHeight = event.target.clientHeight;
			let scrollHeight = event.target.scrollHeight;
			let scrollTop = event.target.scrollTop;
			if(clientHeight == (scrollHeight - scrollTop) && this.isLoading == false)
			{
				this.logger.debug(this, "scrollPaging(event)");
				this.dataPagination.currentPage = this.dataPagination.currentPage + 1;
				this.isLoading = true;
				this.selectDataList();
			}
		},
	}
};
</script>

<style scoped>
.date-range-picker {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 400px;
}

.date-separator {
  color: #666;
  font-weight: bold;
}

.date-input {
  flex: 1;
  min-width: 120px;
}

.search-input[type="date"] {
  min-width: 150px;
  padding: 6px 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  height: 36px;
}

.search-input[type="date"]::-webkit-calendar-picker-indicator {
  cursor: pointer;
  opacity: 1;
}

.search-input[type="date"]::-webkit-inner-spin-button,
.search-input[type="date"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.search-select {
  min-width: 120px;
  padding: 6px 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  height: 36px;
  background-color: white;
}
.search-container {
  margin-bottom: 15px;
}

.search-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.advanced-search-panel {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 15px;
  margin-top: 10px;
}

.search-condition {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.search-select, .search-input {
  padding: 6px 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
}

.search-select {
  min-width: 120px;
}

.search-input {
  flex: 1;
  min-width: 200px;
}

.search-actions {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}

.btn-advanced-search, .btn-add, .btn-apply, .btn-reset {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  transition: background-color 0.2s;
}

.btn-advanced-search {
  background-color: #f0f0f0;
  color: #333;
}

.btn-advanced-search:hover {
  background-color: #e0e0e0;
}

.btn-add {
  background-color: #e9ecef;
  color: #495057;
}

.btn-add:hover {
  background-color: #dee2e6;
}

.btn-apply {
  background-color: #007bff;
  color: white;
}

.btn-apply:hover {
  background-color: #0056b3;
}

.btn-reset {
  background-color: #dc3545;
  color: white;
}

.btn-reset:hover {
  background-color: #bd2130;
}

.btn-remove {
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  padding: 0 5px;
}

.btn-remove:hover {
  color: #bd2130;
}

.yellow {
  background-color: #fff3cd;
}

.btn-cancel {
	margin-right: 10px;
}

.dialog .center {
	overflow: hidden;
}

.scroll-wrap {
	position: relative;
	width: 100%;
	height: calc(100% - 43px);
	overflow-x: scroll;
}

.tb-list-vertical th,
.tb-list-vertical td {
	padding: 0 20px;
	white-space: nowrap;
}

.tb-list-vertical tbody tr:focus>td, .tb-list-vertical tbody tr:hover>td {
	cursor: initial;
}

.scroll-thead-wrap {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	width: max-content;
	height: 54px;
	overflow-y: hidden;
	z-index: 10;
}

.scroll-thead-wrap tbody {
	visibility: hidden;
}

.scroll-tbody-wrap {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	width: max-content;
	height: 100%;
	overflow-y: scroll;
	z-index: 5;
	-ms-overflow-style: none; /* IE and Edge */
	scrollbar-width: none; /* Firefox */
}

.scroll-tbody-wrap::-webkit-scrollbar {
	display: none;
}

.scroll-tbody-wrap thead {
	visibility: hidden;
}

.emr-check {
	margin: 0 10px;
}

.yellow {
	background-color: yellow !important;
}

.row-loading {
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	width: 100%;
	height: 100%;
	font-weight: 600;
	font-size: 11pt;
	color: #999;
}

.row-loading img {
	width: 16px;
	height: 16px;
	margin: 0 10px 0 0;
	animation: loading 1.2s linear infinite both;
}

@keyframes loading {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>import { overflow } from "html2canvas/dist/types/css/property-descriptors/overflow";import { overflow } from "html2canvas/dist/types/css/property-descriptors/overflow";

